import { useEffect, useState } from 'react';
import { TextField } from 'seagull';
import { serviceBillingModel, serviceModel, serviceCostModel } from "../../../models";
import { decimalFromStr } from "../../../infra/utils";
import { getPreapprovedSuffix } from "../../ServiceCreation/ServiceBuilder/ServiceBuilder.utils";
import { AdvancedSettingsControl } from "../AdvancedSettingsControl/AdvancedSettingsControl";
import { AdvancedSetting } from "../ServiceAdvancedSettings";
import styles from "../ServiceAdvancedSettings.module.scss";
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import { jsx as _jsx } from "react/jsx-runtime";
const dropdownWidth = 274;
export function PreapprovedAmountControl(props) {
  const [unitCap, setUnitCap] = useState(null);
  const {
    service,
    testId,
    disabled,
    info,
    label,
    disabledTooltip,
    isReadOnly,
    onPreapprovedAmountChange,
    showServiceValidationWarning
  } = props;
  const [isEnabled, setIsEnabled] = useState(false);
  const recurrencePeriod = serviceBillingModel.recurrencePeriod(service.billing) || 'onetime';
  const errors = serviceModel.validatePreapprovedAmount(service).length > 0;
  const {
    PREAPPROVED_AMOUNT_IMPROVMENTS
  } = useFeatureFlags();
  const suffix = getPreapprovedSuffix(recurrencePeriod);
  useEffect(() => {
    var _serviceModel$changes, _serviceModel$changes2;
    const preapproved = serviceCostModel.unitCap(((_serviceModel$changes = serviceModel.changes(service)) === null || _serviceModel$changes === void 0 ? void 0 : _serviceModel$changes.cost) || service.cost);
    const controlledByAdvancedSettings = serviceCostModel.preapprovedControlledByAdvancedSettings(((_serviceModel$changes2 = serviceModel.changes(service)) === null || _serviceModel$changes2 === void 0 ? void 0 : _serviceModel$changes2.cost) || service.cost);
    setUnitCap(preapproved);
    if (preapproved && preapproved.gt(0)) {
      setIsEnabled(true);
    } else if (!controlledByAdvancedSettings) {
      // if no value and advanced settings is not controlling, uncheck checkbox (serviceBuilder removed it)
      setIsEnabled(false);
      setUnitCap(null);
    }
  }, [service]);
  const handleChange = checked => {
    setIsEnabled(checked);
    if (!checked) {
      setUnitCap(null);
      onPreapprovedAmountChange && onPreapprovedAmountChange(service.id, null, false);
    } else {
      onPreapprovedAmountChange && onPreapprovedAmountChange(service.id, unitCap, true);
    }
  };
  const handleInputChange = value => {
    const parsedValue = decimalFromStr(value);
    setUnitCap(parsedValue);
    if (!value || value.trim() === '') {
      onPreapprovedAmountChange && onPreapprovedAmountChange(service.id, null, true);
    } else {
      onPreapprovedAmountChange && onPreapprovedAmountChange(service.id, parsedValue, true);
    }
  };
  if (!serviceCostModel.isVariablePrice(service.cost)) {
    return null;
  }
  const helperText = () => {
    if (unitCap !== null && unitCap !== void 0 && unitCap.lessThanOrEqualTo(0)) {
      return PREAPPROVED_AMOUNT_IMPROVMENTS ? 'Set cap (greater than 0)' : 'Set cap (0 or higher)';
    }
    if (isEnabled && !unitCap && showServiceValidationWarning && errors && PREAPPROVED_AMOUNT_IMPROVMENTS) {
      return 'Set cap (greater than 0)';
    }
    return '';
  };
  return /*#__PURE__*/_jsx(AdvancedSettingsControl, {
    isReadOnly: isReadOnly,
    info: info,
    label: label,
    checked: isEnabled,
    testid: testId + '-preapproved-amount-checkbox',
    disabled: disabled,
    disabledTooltip: disabledTooltip,
    onChange: handleChange,
    children: isEnabled && /*#__PURE__*/_jsx("div", {
      className: styles.additionalControl,
      children: /*#__PURE__*/_jsx(TextField, {
        size: "small",
        isMoney: true,
        label: "Preapproved amount",
        error: errors,
        helperText: helperText(),
        width: dropdownWidth,
        disabled: isReadOnly,
        value: unitCap ? unitCap.toString() : '',
        suffix: suffix,
        "data-testid": testId + '-preapproved-amount-input',
        onKeyDown: e => {
          if (e.key === '-') {
            e.preventDefault();
          }
        },
        onPaste: e => {
          const pastedText = e.clipboardData.getData('text');
          if (pastedText.includes('-')) {
            e.preventDefault();
          }
        },
        onChange: e => {
          const trimmedValue = e.target.value.slice(0, 7).replace(/-/g, '');
          handleInputChange(trimmedValue);
        }
      })
    })
  }, AdvancedSetting.PreapprovedAmount);
}